import {
  Button,
  Center,
  Flex,
  PasswordInput,
  Stack,
  Text,
  TextInput,
} from '@mantine/core'
import { Link } from '@remix-run/react'
import { z } from 'zod'
import { VALIDATION_MESSAGES } from '~/core/shared/messages'
import { passwordValidationRegex } from '~/core/shared/utils/misc'

type LoginFormProps = {
  validationErrors: Record<string, string[]>
  actionData?: { applicationError?: string }
}

export const loginFormSchema = z.object({
  email: z
    .string({ required_error: VALIDATION_MESSAGES.EMPTY_EMAIL })
    .min(1, { message: VALIDATION_MESSAGES.EMPTY_EMAIL })
    .email({ message: VALIDATION_MESSAGES.INVALID_EMAIL })
    .max(1024, { message: VALIDATION_MESSAGES.MAX_LENGTH_EMAIL }),
  password: z
    .string({ required_error: VALIDATION_MESSAGES.EMPTY_PASSWORD })
    .min(1, { message: VALIDATION_MESSAGES.EMPTY_PASSWORD })
    .min(8, { message: VALIDATION_MESSAGES.MIN_LENGTH_PASSWORD })
    .max(64, { message: VALIDATION_MESSAGES.MAX_LENGTH_PASSWORD })
    .regex(passwordValidationRegex, {
      message: VALIDATION_MESSAGES.CHARACTER_PASSWORD,
    }),
})

export const LoginForm = ({ validationErrors, actionData }: LoginFormProps) => {
  return (
    <>
      <Stack gap='lg'>
        <TextInput
          name='email'
          placeholder='syn-ad@example.com'
          size='lg'
          h={80}
          error={validationErrors.email?.join('\n')}
        />
        <PasswordInput
          name='password'
          placeholder='パスワード'
          size='lg'
          error={validationErrors.password?.join('\n')}
        />
        <Flex justify='center' align='center' gap={0}>
          <Button
            type='submit'
            size='xl'
            w={{ base: '100%', sm: '100%', md: '50%' }}
            mah={80}
          >
            ログイン
          </Button>
        </Flex>
        {actionData?.applicationError && (
          <Center>
            <Text c='error'>{actionData.applicationError}</Text>
          </Center>
        )}

        <Center>
          <Text fw='bold'>パスワードを忘れた方は</Text>
          <Link to='/password/forgot/email'>
            <Text fw='bold'>こちら</Text>
          </Link>
        </Center>
      </Stack>
    </>
  )
}
